import { Component, OnInit } from '@angular/core';
import { Shared } from '../shared.service';
import * as firebase from 'firebase';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {

  popup = 0;
  selectedFile;
  reader: FileReader = new FileReader();
  url;
  hasImage = false;
  imageSet = false;

  constructor(public shared: Shared) {
      this.reader.onload = (event) => {
          //console.log(event);
          this.url = event.target['result']; // THIS IS WHERE INTERFACES FAIL
          this.imageSet = true;
      };
      if(shared.settings.logo != ''){
          this.hasImage = true;
      }
  }

  ngOnInit() {
  }

  setPopup(step){
      this.popup = Number(step);
  }

  placeRequest(){
      this.popup = 2;
  }

  save(){
      if(this.selectedFile){
          this.realUpload();
      } else {
        delete this.shared.settings.$key;
          this.shared.settingsRef.update(this.shared.settings);
      }
  }
  upload(event){
      this.selectedFile = event.target.files[0]
      this.reader.readAsDataURL(this.selectedFile);
  }
  realUpload(){
        let storageRef = firebase.storage().ref();
        return storageRef.child(`/images/${this.shared.firebase_user.dispensary}`).put(this.selectedFile).then((snapshot) => {
            //console.log(snapshot);
            this.hasImage = true;
            this.shared.settings.logo = snapshot.metadata.downloadURLs[0];
            delete this.shared.settings.$key;
            this.shared.settingsRef.update(this.shared.settings);
        });
  }
  canView(){
      return true;
  }


}



// WEBPACK FOOTER //
// ./src/app/details/details.component.ts